import React from 'react';
import { Shield, Trophy, Crown, Gem, Star, ArrowRight } from 'lucide-react';
import { Button } from '@/components/Button';

interface BannerSlideProps {
    isLoggedIn: boolean;
}

export const LevelPromoBannerSlide: React.FC<BannerSlideProps> = ({ isLoggedIn }) => {
    return (
        <div className="w-full shrink-0 flex flex-col md:flex-row items-center gap-6 px-4">
            {/* Left Side: Badges */}
            <div className="flex -space-x-4 md:-space-x-6 relative z-10 shrink-0 select-none group-hover:scale-105 transition-transform duration-500">
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-amber-700 to-amber-900 flex items-center justify-center border-4 border-white dark:border-gray-900 shadow-xl z-10">
                    <Shield className="w-5 h-5 md:w-7 md:h-7 text-white" />
                </div>
                <div className="w-14 h-14 md:w-20 md:h-20 rounded-full bg-gradient-to-br from-slate-300 to-slate-500 flex items-center justify-center border-4 border-white dark:border-gray-900 shadow-xl z-20 -mt-2 md:-mt-4">
                    <Trophy className="w-6 h-6 md:w-8 md:h-8 text-white" />
                </div>
                <div className="w-16 h-16 md:w-24 md:h-24 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center border-4 border-white dark:border-gray-900 shadow-2xl z-30 -mt-4 md:-mt-8">
                    <Crown className="w-8 h-8 md:w-10 md:h-10 text-white drop-shadow-md" />
                </div>
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-cyan-300 to-blue-500 flex items-center justify-center border-4 border-white dark:border-gray-900 shadow-xl z-20">
                    <Gem className="w-5 h-5 md:w-7 md:h-7 text-white" />
                </div>
            </div>

            {/* Content */}
            <div className="flex-1 text-center md:text-left z-10 mt-4 md:mt-0">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/20 rounded-full text-blue-600 dark:text-blue-400 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-3">
                    <Star className="w-3.5 h-3.5 fill-current" />
                    Novidade
                </div>
                <h3 className="text-xl md:text-2xl font-black text-gray-900 dark:text-white mb-2 leading-tight">
                    Conheça o Programa de Níveis!
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 font-medium mb-5 text-balance">
                    Gere links, cumpra missões e suba de nível. Ganhe multiplicadores de pontos, mais pontos em compras aprovadas, prioridade no atendimento e bônus mensais garantidos!
                </p>
                <div className="flex items-center justify-center md:justify-start">
                    <Button
                        variant="primary"
                        className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 shadow-lg shadow-purple-500/25 border-0 text-sm px-6 py-2.5 whitespace-nowrap"
                    >
                        {isLoggedIn ? 'Ver Meus Benefícios' : 'Quero Participar'}
                        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                </div>
            </div>
        </div>
    );
};
